import React, { FC } from 'react';

const HpRespAppBanner = React.lazy(() =>
    import(/* webpackChunkName: "HpRespAppBanner" */ './HpRespAppBanner')
);

export const HpRespAppBannerLazy: FC = () => {
    return (
        <React.Suspense fallback="">
            <HpRespAppBanner />
        </React.Suspense>
    );
};
